'use strict';

var ConfigurationLinkedFbcController = function ConfigurationLinkedFbcController($scope, dataRetrieverService, configurationLinkedFbcService, dataRetrieverConstantsService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_FO_LINKED_FBC_MODE).setCustomSearchCriteriaRules([]);
  $scope.makeExportToCsv = function (data) {
    configurationLinkedFbcService.exportToCsv(data);
  };
  $scope.customRemove = function (rowsToBeRemovedFromServer) {
    configurationLinkedFbcService.remove(rowsToBeRemovedFromServer);
  };
  $scope.customSave = function (editedRows) {
    return configurationLinkedFbcService.save(editedRows);
  };
  $scope.customSaveValidation = function (editedRows, gridData) {
    return configurationLinkedFbcService.validate(editedRows, gridData);
  };
};
ConfigurationLinkedFbcController.$inject = ['$scope', 'DataRetrieverService', 'ConfigurationLinkedFbcService', 'DataRetrieverConstantsService'];
module.exports = ConfigurationLinkedFbcController;